import moment from "moment";

export const frequencyOptions = [
  {
    label: "Does not repeat",
    value: "none",
  },
  // {
  //   label: "Every weekday (Mon - Fri)",
  //   value: "weekdays",
  // },
  {
    label: "Daily",
    value: "daily"
  },
  {
    label: "Weekly",
    value: "weekly"
  },
  {
    label: "Monthly",
    value: "monthly"
  },
  {
    label: "Yearly",
    value: "yearly"
  }
]

export const repeatOptions = [{
  label: "Day",
  value: "Day"
}, {
  label: "Week",
  value: "Week"
}, {
  label: "Month",
  value: "Month"
}, {
  label: "Year",
  value: "Year"
}];

export const monthWeekOptions = [{
  label: "First",
  value: "first",
  sequence: 1
}, {
  label: "Second",
  value: "second",
  sequence: 2
}, {
  label: "Third",
  value: "third",
  sequence: 3
}, {
  label: "Fourth",
  value: "fourth",
  sequence: 4
}, {
  label: "Last",
  value: "last",
  sequence: 5
}];

export const dayOptions = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const weekDayOptions = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const monthOptions = [
  {
    label: "January",
    value: "January",
    sequence: 1
  },
  {
    label: "February",
    value: "February",
    sequence: 2
  },
  {
    label: "March",
    value: "March",
    sequence: 3
  },
  {
    label: "April",
    value: "April",
    sequence: 4
  },
  {
    label: "May",
    value: "May",
    sequence: 5
  },
  {
    label: "June",
    value: "June",
    sequence: 6
  },
  {
    label: "July",
    value: "July",
    sequence: 7
  },
  {
    label: "August",
    value: "August",
    sequence: 8
  },
  {
    label: "September",
    value: "September",
    sequence: 9
  },
  {
    label: "October",
    value: "October",
    sequence: 10
  },
  {
    label: "November",
    value: "November",
    sequence: 11
  },
  {
    label: "December",
    value: "December",
    sequence: 12
  }
];

export const getAdditionalTotal = (fields) => {
  let additionalCost = parseFloat(fields.misc_rate);
  let units = parseFloat(fields.misc_units);
  let adjustment = parseFloat(fields.misc_adjustment_cost);
  let subTotal = 0;
  if (!isNaN(adjustment) && !isNaN(additionalCost)) {
    subTotal = additionalCost + adjustment;
  }
  if (!isNaN(units)) {
    if (units > 0) {
      subTotal = subTotal * units;
    }
  }

  return subTotal;
}

export const getFrequencyString = (frequency, selectedDays) => {
  let str = "";
  if (frequency) {
    let repeatType = frequency.repeat_type;
    if (repeatType && repeatType.value === "Week" && frequency.repeat_value && parseInt(frequency.repeat_value) > 0) {
      str = "Occurs every";
      if (frequency.repeat_value !== "1") {
        str += ` ${frequency.repeat_value} weeks on`
      }
      let days = [...dayOptions.filter(x => selectedDays.includes(x))];
      if (days.length === 7) {
        str += " day";
      } else if (days.length > 1) {
        str += ` ${days.splice(0, days.length - 1).join(", ")} and ${days[days.length - 1]}`
      } else {
        str += ` ${days.join(", ")}`
      }
    } else if (repeatType && repeatType.value === "Day" && frequency.repeat_value && parseInt(frequency.repeat_value) > 0) {
      str = `Occurs every ${frequency.repeat_value && frequency.repeat_value === "1" ? "day" : frequency.repeat_value + " days"}`
    } else if (repeatType && repeatType.value === "Month" && frequency.repeat_value && parseInt(frequency.repeat_value) > 0) {
      str = `Occurs every`;
      if (frequency.repeat_value === "1") {
        str += ` month `
      } else {
        str += ` ${frequency.repeat_value} months`
      }

      if (frequency.month_value && frequency.month_value === 1 && frequency.month_day_number) {
        str += ` on day ${frequency.month_day_number}`
      } else if (frequency.month_value && frequency.month_value === 2 && frequency.month_week && frequency.month_day) {
        str += ` on the ${frequency.month_week.value} ${frequency.month_day.value}`
      }
    } else if (repeatType && repeatType.value === "Year") {
      str = `Occurs every year`
      if (frequency.year_value && frequency.year_value.toString() === "1" && frequency.year_month && frequency.year_month_day_number) {
        str += ` on day ${frequency.year_month_day_number} of ${frequency.year_month.value}`
      } else if (frequency.year_value && frequency.year_value.toString() === "2" && frequency.year_month_day && frequency.year_month_week && frequency.year_month_name) {
        str += ` on the ${frequency.year_month_week.value} ${frequency.year_month_day.value} of ${frequency.year_month_name.value}`
      }
    }

    if (frequency.freq_end_date && str.length > 0) {
      str += ` until ${moment(frequency.freq_end_date).format("DD-MM-YYYY")}.`
    }
  }
  return str;
}

export const getFrequencyPattern = (frequencyType, frequency, taskDuration = { value: "1_Day" }) => {
  let freqData = {};
  freqData.task_duration = taskDuration.value
  freqData.freq_start_date = moment(frequency.freq_start_date).format("YYYY-MM-DD")
  freqData.freq_end_date = moment(frequency.freq_end_date).format("YYYY-MM-DD")
  if (frequencyType.value.toLowerCase() === "daily") {
    freqData.freq_type = "DAILY";
    freqData.pattern = {
      type: "D_EVERY_DAY",
      repeat_every: frequency.repeat_value
    }
  }
  if (frequencyType.value.toLowerCase() === "weekdays") {
    freqData.freq_type = "DAILY";
    freqData.pattern = { type: "D_EVERY_WEEK_DAY" }
  }

  if (frequencyType.value.toLowerCase() === "weekly") {
    freqData.freq_type = "WEEKLY";
    freqData.pattern = {
      type: "D_EVERY_WEEK",
      repeat_every: frequency.repeat_value,
      day: frequency.selected_days.join("|")
    }
  }

  if (frequencyType.value.toLowerCase() === "monthly") {
    freqData.freq_type = "MONTHLY";
    if (frequency.month_value.toString() === "1") {
      freqData.pattern = {
        type: "M_DATE_OF_EVERY_MONTH",
        day_of_month: frequency.month_day_number,
        repeat_every: frequency.repeat_value
      }
    } else {
      freqData.pattern = {
        type: "M_DAY_OF_EVERY_MONTH",
        day_of_month: frequency.month_week.sequence,
        day: frequency.month_day.value,
        repeat_every: frequency.repeat_value
      }
    }
  }

  if (frequencyType.value.toLowerCase() === "yearly") {
    freqData.freq_type = "YEARLY"
    if (frequency.year_value.toString() === "1") {
      freqData.pattern = {
        type: "Y_DATE_OF_MONTH",
        day_of_month: frequency.year_month_day_number,
        month: frequency.year_month.sequence,
        repeat_every: frequency.repeat_value
      }
    } else {
      freqData.pattern = {
        type: "Y_DAY_OF_MONTH",
        day_of_month: frequency.year_month_week.sequence,
        day: frequency.year_month_day.value,
        month: frequency.year_month_name.sequence,
        repeat_every: frequency.repeat_value
      }
    }
  }

  if (frequencyType.value.toLowerCase() === "none") {
    freqData.freq_type = "NONE";
    freqData.pattern = { type: "NONE" };
  }

  return freqData;
}
